import React from "react";
import {Stack, Text, StackProps, Image} from "@chakra-ui/core";

import Heading from "~/ui/display/Heading";
import Content from "~/ui/structure/Content";
import {useTranslation} from "~/i18n/hooks";
import { HERO } from "~/constanst/plans";

const PlansHero: React.FC<StackProps> = (props) => {
  const t = useTranslation();

  return (
    <Content
      backgroundColor="primary.100"
      paddingBottom={{base: 6, md: 20}}
      paddingX={6}
      {...props}
    >
      <Stack
        shouldWrapChildren
        flex={1}
        margin="auto"
        marginTop={6}
        maxWidth={850}
        spacing={10}
        textAlign={{base: "left", md: "center"}}
      >
        <Stack spacing={6}>
          <Image
            alt={HERO.imageAlt}
            margin="auto"
            src={HERO.image}
            width={{base: "100%", md: 320}}
          />
          <Heading as="h2" fontSize={{base: "4xl", md: "5xl"}} color="green.400">
            {t(HERO.title)}
          </Heading>
          <Text as="h3" fontSize={{base: "md", md: "lg"}}>
            {t(HERO.subtitle)}
          </Text>
        </Stack>
      </Stack>
    </Content>
  );
};

export default PlansHero;
